var React = require('react');

function Icon(props) {
  return React.cloneElement(
    React.createElement(
      'svg',
      { height: '24', width: '24', viewBox: '0 0 24 24' },
      React.createElement('path', {
        d:
          'M23 5.89379C22.2644 6.21496 21.4731 6.43215 20.6431 6.52997C21.4906 6.02976 22.1413 5.23853 22.4475 4.29533C21.655 4.75801 20.7763 5.09394 19.8419 5.27545C19.0931 4.49037 18.0269 4 16.8469 4C14.5806 4 12.7437 5.80827 12.7437 8.03922C12.7437 8.35547 12.78 8.66372 12.85 8.95966C9.43938 8.79108 6.41625 7.18277 4.3925 4.73893C4.03937 5.33574 3.83687 6.02976 3.83687 6.76993C3.83687 8.17089 4.56125 9.40758 5.66187 10.1317C4.98937 10.1108 4.35688 9.92932 3.80375 9.62661C3.80313 9.64384 3.80312 9.66045 3.80312 9.67768C3.80312 11.6348 5.2175 13.2671 7.095 13.6381C6.75062 13.7304 6.38812 13.7797 6.01375 13.7797C5.74938 13.7797 5.4925 13.7544 5.24188 13.7077C5.76375 15.3123 7.27938 16.4801 9.075 16.5127C7.67062 17.5962 5.90125 18.2416 3.97875 18.2416C3.6475 18.2416 3.32125 18.2225 3 18.1856C4.81562 19.3312 6.9725 20 9.29 20C16.8375 20 20.9644 13.8449 20.9644 8.50744C20.9644 8.33209 20.9606 8.15797 20.9525 7.98446C21.7544 7.41534 22.45 6.7041 23 5.89379Z'
      })
    ),
    props
  );
}

module.exports = Icon;
